import { CountryCode, NumberType } from 'libphonenumber-js/core';

import { IMobileValidatorParams } from '~types/validator';

import { string as yupString } from 'yup';

const YUP_PHONE_TEST_NAME = 'phone';

interface IPhoneTestConfig {
    countryCode: CountryCode;
    numberType?: NumberType;
    errorMessage: string;
}

// TODO: create with [memoize-one](https://www.npmjs.com/package/memoize-one)
const getPhoneTest = ({ countryCode, numberType, errorMessage }: IPhoneTestConfig) => {
    return yupString().test(YUP_PHONE_TEST_NAME, errorMessage, async (value) => {
        if (!value) {
            return true;
        }

        // Align with how `PhoneInput` component set value
        const { createAsYouType } = await import('./phone-number-helper');
        const asYouType = createAsYouType(countryCode);
        asYouType.input(value);

        if (value === `+${asYouType.getCallingCode()}`) {
            return true;
        }

        const phoneNumber = asYouType.getNumber();
        if (!phoneNumber) {
            return false;
        }

        return (
            phoneNumber.isValid() &&
            phoneNumber.country === countryCode &&
            (!numberType || phoneNumber.getType() === numberType)
        );
    });
};

// HACK: A registered FormValidator method accepts up to 2 parameters by design (msg and params, see @estee/elc-form FormValidator), we utilize the 'msg' positional parameter to pass in our custom configs.
export function validateMobile({
    numberType,
    patterns,
    errorMessage = ''
}: IMobileValidatorParams) {
    if (patterns) {
        // support TW multiple area
        /** @ts-ignore */
        const code = this.values.areaCode as string; // `this` is elc-form FormStore
        const regExp = new RegExp(patterns[code] || patterns.default);

        return yupString().matches(regExp, errorMessage);
    } else {
        /** @ts-ignore */
        const countryCode = this.values._countryCode;

        if (!countryCode) {
            return yupString();
        }

        return getPhoneTest({ countryCode, numberType, errorMessage });
    }
}
